import Echo from "laravel-echo"
import Pusher from "pusher-js"
import api from "./api"

const options: any = {
  broadcaster: "pusher",
  key: process.env.REACT_APP_PUSHER_KEY,
  cluster: process.env.REACT_APP_PUSHER_CLUSTER,
}

export const echo = new Echo({
  ...options,
  forceTLS: true,
  client: new Pusher(options.key, {
    ...options,
    authorizer: (channel, options) => {
      return {
        authorize: (socketId, callback) => {
          api
            .post("/api/broadcasting/auth", {
              socket_id: socketId,
              channel_name: channel.name,
            })
            .then((response: any) => {
              callback(null, response)
            })
            .catch((error) => {
              callback(null, error)
            })
        },
      }
    },
  }),
})
